var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 14 16",
    width: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m1.6002.799805c.49705 0 .9.402945.9.899995v1.89113c1.14308-1.16673 2.73646-1.89113 4.5-1.89113 2.74446 0 5.0769 1.75439 5.9413 4.20008.1656.46865-.08.98284-.5487 1.14848-.4686.16564-.9828-.07999-1.1484-.54863-.6182-1.74901-2.28628-2.99993-4.2442-2.99993-1.47144 0-2.77917.70652-3.60059 1.8h2.70059c.49705 0 .9.40295.9.9 0 .49706-.40295.9-.9.9h-4.5c-.49706 0-.900005-.40294-.900005-.9v-4.5c0-.49705.402945-.899995.900005-.899995zm.00734 8.151445c.46865-.16564.98284.07999 1.14848.54863.61819 1.74902 2.28625 2.99992 4.24418 2.99992 1.47143 0 2.77916-.7065 3.6006-1.8h-2.7006c-.49706 0-.9-.4029-.9-.9 0-.49705.40294-.89999.9-.89999h4.5c.2387-.00001.4676.09482.6364.2636s.2636.3977.2636.63639v4.5c0 .4971-.4029.9-.9.9s-.9-.4029-.9-.9v-1.8911c-1.1431 1.1667-2.73647 1.8911-4.5 1.8911-2.74447 0-5.07686-1.7544-5.94129-4.2001-.165642-.46862.07999-.98281.54863-1.14845z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.791df4e74be43492a15901164f921d24.svg";
export { ForwardRef as ReactComponent };